import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.title-non-final',
		defaultMessage: 'Your work from Opsgenie is shifting to Jira',
		description: 'Title for the first unlocked admin content for the optimal wizard',
	},
	descriptionNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.description-non-final',
		defaultMessage:
			'Almost all of your Opsgenie data and settings are now in Jira Service Management, so you no longer need Opsgenie to do your alerting and on-call work.',
		description: 'Description for the first unlocked admin content for the optimal wizard',
	},
	listTitleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.list-title-non-final',
		defaultMessage: 'Let’s go set up a few things so your team can get started',
		description:
			'Title for the list of configurations that need to be set up for the optimal wizard',
	},
	configureChatIntegrationsNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.configure-chat-integrations-non-final',
		defaultMessage: 'Configure chat integrations in Jira Service Management',
		description: 'Description for configuring chat integrations for the optimal wizard',
	},
	giveProductAdminRoleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-admin-role-non-final',
		defaultMessage:
			'Give the product admin role to {adminCount, plural, one {# Opsgenie admin} other {# Opsgenie admins}}',
		description:
			'Description for giving the product admin role to Opsgenie admins for the optimal wizard',
	},
	giveProductRoleNonFinal: {
		id: 'eoc-changeboarding.wizard.optimal.steps.five.content.admin.give-product-role-non-final',
		defaultMessage:
			'Give a product role to {userCount, plural, one {# Opsgenie user} other {# Opsgenie users}} who no longer have a custom role',
		description: 'Description for giving a product role to Opsgenie users for the optimal wizard',
	},
});
